module.exports = __webpack_public_path__ + "img/Video-Off.095c2a05.svg";